import { computed } from 'vue';
import { useFeatureFlags } from '@/helpers/useFeatureFlags';
import { useRequestIncomeExpenseProcess } from '@/helpers/useRequestIncomeExpenseProcess';

/**
 * Whether the income/expense request being filled in belongs to an ERHL application.
 *
 * This keys off the application's own `lendingProduct` rather than the requesting
 * broker's ERHL access (JS-10089). The two used to be conflated — the flow identified
 * Flagsmith with the application's `brokerId` and read the pilot trait — but they answer
 * different questions. The forms here ask "is this an ERHL application", and that stays
 * true regardless of what access the broker holds today, which matters because the
 * person filling this in is the customer, not the broker.
 *
 * It also could not have stayed as it was: access is now resolved for the authenticated
 * user, and nothing lets a customer-token session ask about an arbitrary broker.
 *
 * The environment-level `erhl-product` flag remains the outer gate.
 */
export const useErhlIncomeExpense = () => {
  const { isErhlProductEnabled } = useFeatureFlags();
  const { state } = useRequestIncomeExpenseProcess();

  const isErhlIncomeExpense = computed(() => {
    return isErhlProductEnabled() && state.value.context.loanApp.lendingProduct === 'erhl';
  });

  return { isErhlIncomeExpense };
};
